module.exports = __webpack_public_path__ + "img/item-3(1920)new.8696b27a.jpg";